// Get Parameter from URL
const getURLParam = (param) => {
  let result = null;
  let tmp = [];
  const items = location.search.substr(1).split('&');
  for (let index = 0; index < items.length; index++) {
    tmp = items[index].split('=');
    if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
  }
  return result;
};
const getScriptParam = (param) => {
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    // coger el conf del id
    if (
      scripts[i].src.indexOf('/inbenta-conf-chile.min.js') > -1 ||
      scripts[i].src.indexOf('/inbenta-conf-peru.min.js') > -1 ||
      scripts[i].src.indexOf('/inbenta-conf-argentina.min.js') > -1 ||
      scripts[i].src.indexOf('/inbenta-conf-chile-corporate.min.js') > -1 ||
      scripts[i].src.indexOf('/inbenta-conf-otros.min.js') > -1
    ) {
      const params = scripts[i].src.split('?').pop().split('&');
      for (let j = 0; j < params.length; j++) {
        const paramName = params[j].split('=')[0];
        const paramValue = params[j].split('=')[1];
        if (paramName === param) return paramValue;
      }
    }
  }
  return false;
};
export {
  getURLParam, getScriptParam
};
